<template>
  <div class="invite-con">
    <!-- 浏览器提示 -->
    <div class="bg_img" style="background: rgba(225,225,225,0.4);">
      <!-- 星空 -->
      <constellation></constellation>
    </div>
    <div class="invite bg-100" :class="{'mobile-wrap': isMobile}">
      <sign-in
        v-if="isSignInShow && !(isLogin === true) && !isSuccess"
        @signIn="inviteRegister" />
      <expiration
        @backToLogin="backToLogin"
        v-if="isInviteValid === false" />
<!--      <SignInSuccess-->
<!--        v-if="isSuccess"-->
<!--        @backToLogin="backToLogin" />-->
      <invite-tips
        v-if="isInviteValid === true && !isSignInShow"
        @joinProject="joinProject"
        :inviter="inviter"
        :project="project"/>
    </div>
  </div>
</template>

<script setup>
import constellation from '@/components/core/constellation.vue'
import SignIn from '@/views/invite/components/sign-in.vue'
import Expiration from '@/views/invite/components/expiration.vue'
import InviteTips from '@/views/invite/components/invite-tips.vue'
import { computed, defineProps, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import api from '@/services/api'
import { Modal } from '@arco-design/web-vue'
import { client } from '@/router/path'

const props = defineProps({
  inviteId: {
    type: String,
    default: ''
  }
})

const isMobile = computed(() => {
  return store.state.breakpoint < store.state.breakpointList.sm
})

const store = useStore()
const router = useRouter()
const route = useRoute()
const isLogin = ref(null)
const isInviteValid = ref(null)
const isSuccess = ref(false)
const isSignInShow = ref(false)
const inviter = ref('')
const project = ref('')
const orgId = ref(null)
const projectId = ref(null)
const emailRegistered = ref(false)

onMounted(async () => {
  checkHref()
  await checkToken()
  await checkInviteId()
})

const checkHref = () => {
  console.log(route)
  const urlList = window.location.href.split('%20')
  if (urlList && urlList.length > 1) {
    window.location.href = urlList[0]
  }
}

const checkToken = async () => {
  const token = store.state.token
  if (token && token.length) {
    isLogin.value = true
  }
}

const backToLoginWithEmail = () => {
  const num = Object.keys(route.query)
  console.log(num)
  router.push({
    name: 'Login',
    query: { redirect: window.location.href + `${num && num.length ? '&' : '?'}join=true`, email: route.query.email }
  })
}

const checkInviteId = async () => {
  if (props.inviteId) {
    try {
      const email = route.query.email
      const res = await api.invite.checkInviteId({
        inviteId: props.inviteId,
        email
      })
      if (res && res.code === 200) {
        projectId.value = res.data?.project?.projectId
        orgId.value = res.data?.org?.orgId
        emailRegistered.value = res.data.emailRegistered
        if (route?.query?.join) {
          joinProject()
        } else {
          inviter.value = res.data?.user?.nickName
          project.value = res.data?.project?.name
          isInviteValid.value = true
        }
      } else {
        isInviteValid.value = false
      }
    } catch (error) {
      console.error(error)
    }
  }
}

const inviteRegister = async (values = {}, isPhone) => {
  const inviteId = props.inviteId
  const { password, username, email, phone, smsCode, currentUserId } = values

  if (inviteId) {
    console.log(values)
    let data = {}
    if (isPhone) {
      data = {
        inviteId,
        currentUserId,
        type: 'sms',
        phone: phone && phone.length ? phone : undefined,
        smsCode: smsCode && smsCode.length ? smsCode : undefined,
        nickName: username && username.length ? username : undefined,
        password: password && password.length ? password : undefined
      }
    } else {
      data = {
        inviteId,
        currentUserId,
        type: 'email',
        email: email && email.length ? email : undefined,
        nickName: username && username.length ? username : undefined,
        password: password && password.length ? password : undefined
      }
    }
    try {
      console.log(api)
      const res = await api.invite.inviteRegister(data, isPhone)
      if (res && res.code === 200) {
        if (isLogin.value) {
          goToProject()
        } else {
          // isSuccess.value = true
          backToLogin()
        }
      } else {
        if (isLogin.value) {
          router.push('/')
          // isInviteValid.value = false
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
}

const backToLogin = () => {
  router.push({
    name: 'Login'
  })
}

const goToProject = () => {
  router.push({
    name: 'Project',
    params: {
      orgId: orgId.value,
      projectId: projectId.value
    }
  })
}

const joinProject = async () => {
  if (isLogin.value) {
    // 获取当前登录用户信息
    const res = await api.user.getInfoV2()

    await inviteRegister({
      currentUserId: res.data.userId
    })
  } else {
    if (emailRegistered.value) {
      backToLoginWithEmail()
    } else {
      isSignInShow.value = true
    }
  }
}
</script>

<style scoped lang="less">
  .invite-con {
    width: 100%;
    position: relative;
    overflow: hidden;
    height: 100%;
    .mobile-wrap {
      top: -28px !important;
      transform: translate(-50%, 0%) !important;
      box-shadow: none !important;
      max-width: calc(100%) !important;
      overflow: auto !important;
      height: calc(100% + 28px) !important;
    }
    .invite {
      width: 544px;
      max-width: calc(100% - 32px);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      background: white;
      overflow: hidden;
    }
  }
</style>
